import type { Issue, EpicField } from '@atlassian/jira-software-backlog-uif-types';

export interface IssueWithEpic extends Issue {
	epicField: EpicField;
}

export function hasEpicField(issue: Issue): issue is IssueWithEpic {
	return issue && 'epicField' in issue;
}

export function isEpicField(value: EpicField): value is EpicField {
	return value && 'issueId' in value;
}
